var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryPointNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2168_16899",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.0001,
    height: 18.0001,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2168_16899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50001 15.7501C4.0875 15.7501 3.7345 15.6033 3.441 15.3098C3.147 15.0158 3 14.6626 3 14.2501V7.50003C3 7.26253 3.05325 7.03753 3.15975 6.82503C3.26575 6.61252 3.4125 6.43752 3.6 6.30002L8.10002 2.925C8.23752 2.825 8.38127 2.75 8.53127 2.7C8.68127 2.65 8.83752 2.625 9.00002 2.625C9.16252 2.625 9.31878 2.65 9.46878 2.7C9.61878 2.75 9.76253 2.825 9.90003 2.925L14.4 6.30002C14.5875 6.43752 14.7345 6.61252 14.841 6.82503C14.947 7.03753 15 7.26253 15 7.50003V14.2501C15 14.6626 14.8533 15.0158 14.5598 15.3098C14.2658 15.6033 13.9125 15.7501 13.5 15.7501H10.5V10.5H7.50002V15.7501H4.50001Z",
    fill: "#595959"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryPointNode);
export default __webpack_public_path__ + "static/media/delivery-point-node.c61b6edaa53411b800e38a0fc41e3b06.svg";
export { ForwardRef as ReactComponent };